module.exports = __webpack_public_path__ + "static/img/mobile.74a2c3e8.png";